import React from 'react';

import { AllTaskList } from '../../../../widgets/tasks/ui/AllTaskList';

export const TasksPage = () => {
  return <AllTaskList />;
};
